/* unplugin-vue-components disabled */import { render } from "./member_collect.vue?vue&type=template&id=4ec02fae&scoped=true"
import script from "./member_collect.vue?vue&type=script&lang=js"
export * from "./member_collect.vue?vue&type=script&lang=js"

import "./member_collect.vue?vue&type=style&index=0&id=4ec02fae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec02fae"]])

export default __exports__